import React from 'react'
import HistoryTextBox from './HistoryTextBox'
import HistoryViewButton from './HistoryViewButton'
import allImgPaths from 'assets/images'
import HistoryFileUpload from './HistoryFileUpload';
import useAppState from 'context/useAppState';
import { format } from 'date-fns';
import { isArray } from 'lodash';
// import { EVENT_FIELDS } from 'utils/constant';

interface FeteManagementProps {
    data: any,
    activityIcon?: any;
    period: any
}

const EVENT_FIELDS: any = {
    start_date: 'start date',
    end_date: 'end date',
    format: 'format',
    name: 'name',
    max: 'max',
    min: 'min',
    times: 'times',
    locations: 'locations',
    type: 'type',
    attendees: 'attendees',
    budget: 'budget',
    objective: 'objective',
    time_zone: 'time zone'
}

const FeteManagement = ({ data, activityIcon, period }: FeteManagementProps) => {
    const {
        eventFetchedData
    } = useAppState("eventData");

    const handleImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    return (
        <>
            <div className="px-3 pt-3 pb-4 mb-5 last:pb-3 last:mb-0 border-b border-[#F1F1F1] last:border-b-transparent">
                <div className="flex gap-x-4 mb-4">
                    <div className="relative w-10">
                        <img className="min-w-10 h-10 rounded-full" onError={handleImageError} src={data?.user?.profile_image || allImgPaths.defaultProfile} alt="" />
                        <img
                            className="absolute top-7 -right-1 w-5 h-5 rounded-full"
                            src={allImgPaths.historyNewFate}
                            alt=""
                        />
                    </div>

                    {
                        data?.action_data?.action_text === 'event-updated' &&
                        <div className="leading-none">
                            {
                                (typeof data?.action_data?.old_value === 'string' && typeof data?.action_data?.new_value === 'string') &&

                                <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                                    <span className="font-interMedium text-base text-[#0A090B]">
                                        {data?.action_data?.action_user?.name || 'A user'}
                                    </span>
                                    <span> updated </span>
                                    <span>
                                        {data?.action_data?.fields && EVENT_FIELDS[data?.action_data?.fields] || ''}
                                    </span>
                                    {/* <span className="font-interMedium text-base text-[#1751D0]">
                                        {
                                            data?.action_data?.old_value &&
                                            data?.action_data?.fields === 'start_date' || data?.action_data?.fields === 'end_date'
                                                ? format(data?.action_data?.old_value, 'EEEE, MMM d, yyyy')
                                                : data?.action_data?.old_value
                                        }
                                    </span> */}

                                    {
                                        data?.action_data?.old_value &&
                                            (data?.action_data?.fields === 'start_date' || data?.action_data?.fields === 'end_date')
                                            ? <>
                                                {data?.action_data?.old_value && <span> from </span>}
                                                <span className="font-interMedium text-base text-[#1751D0]"> {format(data?.action_data?.old_value, 'EEEE, MMM d, yyyy')} </span>
                                            </>
                                            : <>
                                                {data?.action_data?.old_value && <span> from </span>}
                                                <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.old_value} </span>
                                            </>
                                    }

                                    <span> to </span>
                                    <span className="font-interMedium text-base text-[#1751D0]">
                                        {
                                            data?.action_data?.new_value &&
                                                data?.action_data?.fields === 'start_date' || data?.action_data?.fields === 'end_date'
                                                ? format(data?.action_data?.new_value, 'EEEE, MMM d, yyyy')
                                                : data?.action_data?.new_value
                                        }
                                    </span>
                                </div>
                            }
                            {
                                (typeof data?.action_data?.old_value !== 'string' && typeof data?.action_data?.new_value !== 'string') &&
                                (isArray(data?.action_data?.new_value)) &&

                                <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                                    <span className="font-interMedium text-base text-[#0A090B]">
                                        {data?.action_data?.action_user?.name || 'A user'}
                                    </span>
                                    <span> updated </span>
                                    <span>
                                        {data?.action_data?.fields && EVENT_FIELDS[data?.action_data?.fields] || ''}
                                    </span>
                                    <>
                                        {
                                            data?.action_data?.fields === 'locations' &&
                                            <>
                                                {data?.action_data?.old_value?.length > 0 &&
                                                    <>
                                                        <span> from </span>
                                                        <span className="font-interMedium text-base text-[#1751D0]">
                                                            {data.action_data.old_value.join(', ')}
                                                        </span>
                                                    </>
                                                }

                                                <span> to </span>

                                                {data?.action_data?.new_value?.length > 0 &&
                                                    <>
                                                        <span className="font-interMedium text-base text-[#1751D0]">
                                                            {data.action_data.new_value.join(', ')}
                                                        </span>
                                                    </>
                                                }
                                            </>
                                        }
                                        {
                                            data?.action_data?.fields === 'times' &&
                                            <>
                                                <span> to </span>
                                                {data?.action_data?.new_value?.length > 0 &&
                                                    <>
                                                        {
                                                            <ul className="font-interMedium text-base text-[#1751D0]">
                                                                {data?.action_data?.new_value.map((nv: any, nvIndex: number) => (
                                                                    <li key={nvIndex}>
                                                                        {
                                                                            nv.startDate &&
                                                                            <span>Start date: {format(nv.startDate, 'MMM d, yyyy')},</span>
                                                                        }
                                                                        Start time: {nv.startTime},
                                                                        End time: {nv.endTime}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                </div>
                            }
                            {
                                (typeof data?.action_data?.old_value !== 'string' && typeof data?.action_data?.new_value !== 'string') &&
                                (!isArray(data?.action_data?.new_value)) &&

                                <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                                    <span className="font-interMedium text-base text-[#0A090B]">
                                        {data?.action_data?.action_user?.name || 'A user'}
                                    </span>
                                    <span> updated </span>
                                    <span>
                                        {data?.action_data?.fields && EVENT_FIELDS[data?.action_data?.fields] || ''}
                                    </span>

                                    <>
                                        {
                                            <>
                                                {(data?.action_data?.old_value?.min > -1 && data?.action_data?.new_value.min > -1) &&
                                                    <>
                                                        <span> minimum value from </span>
                                                        <span className="font-interMedium text-base text-[#1751D0]">
                                                            {
                                                                data?.action_data?.old_value.min || 0
                                                            }
                                                        </span>
                                                        <span> to </span>
                                                        {
                                                            data?.action_data?.new_value.min &&

                                                            <span className="font-interMedium text-base text-[#1751D0]">
                                                                {
                                                                    data?.action_data?.new_value.min || 0
                                                                }
                                                            </span>
                                                        }
                                                    </>
                                                }
                                                {(data?.action_data?.old_value?.max > -1 && data?.action_data?.new_value.max > -1) &&
                                                    <>
                                                        {(data?.action_data?.old_value?.min > -1 && data?.action_data?.new_value.min > -1) &&
                                                            <span> and </span>
                                                        }
                                                        <span> maximum value from </span>
                                                        <span className="font-interMedium text-base text-[#1751D0]">
                                                            {
                                                                data?.action_data?.old_value.max || 0
                                                            }
                                                        </span>
                                                        <span> to </span>
                                                        {
                                                            data?.action_data?.new_value.max &&

                                                            <span className="font-interMedium text-base text-[#1751D0]">
                                                                {
                                                                    data?.action_data?.new_value.max || 0
                                                                }
                                                            </span>
                                                        }
                                                    </>
                                                }
                                                {data?.action_data?.old_value?.min < 0 && data?.action_data?.new_value?.min > -1 &&
                                                    <>
                                                        <span> minimum value to </span>
                                                        <span className="font-interMedium text-base text-[#1751D0]">
                                                            {
                                                                data?.action_data?.new_value.min || 0
                                                            }
                                                        </span>
                                                    </>
                                                }
                                                {data?.action_data?.old_value?.max < 0 && data?.action_data?.new_value?.max > -1 &&
                                                    <>
                                                        <span> and maximum value to </span>
                                                        <span className="font-interMedium text-base text-[#1751D0]">
                                                            {
                                                                data?.action_data?.new_value.max || 0
                                                            }
                                                        </span>
                                                    </>
                                                }
                                            </>
                                        }
                                    </>

                                    {/* <span className="font-interMedium text-base text-[#0A090B]">
                                        {
                                            data?.action_data?.old_value
                                        }
                                    </span> */}
                                    {/* <span> to </span>
                                    <span className="font-interMedium text-base text-[#0A090B]">
                                        {
                                            data?.action_data?.new_value
                                        }
                                    </span> */}
                                </div>
                            }
                            <div className="leading-none flex items-center gap-x-2.5">
                                {
                                    (period == 'Today' || period == 'Yesterday') &&
                                    <span className="text-xs text-[#7F7D83]">
                                        {format(data?.createdAt, 'hh:mm a')}
                                    </span>
                                }
                                {
                                    period != 'Today' && period != 'Yesterday' &&
                                    <span className="text-xs text-[#7F7D83]">
                                        {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                    </span>
                                }
                                <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                                <span className="text-xs text-[#7F7D83]">
                                    Fete Settings
                                </span>
                            </div>
                        </div>
                    }

                    {
                        data?.action_data?.action_text === 'event-created' &&
                        <div className="leading-none">
                            <p className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                                <span className="font-interMedium text-base text-[#0A090B]">
                                    {data?.action_data?.action_user?.name || 'A user'}&nbsp;
                                </span>
                                created a new event titled&nbsp;
                                <span className="font-interMedium text-base text-[#1751D0]">
                                    {data?.action_data?.new_value || eventFetchedData?.name}&nbsp;
                                </span>
                            </p>
                            <div className="leading-none flex items-center gap-x-2.5">
                                {/* <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                </span> */}
                                {
                                    (period == 'Today' || period == 'Yesterday') &&
                                    <span className="text-xs text-[#7F7D83]">
                                        {format(data?.createdAt, 'hh:mm a')}
                                    </span>
                                }
                                {
                                    period != 'Today' && period != 'Yesterday' &&
                                    <span className="text-xs text-[#7F7D83]">
                                        {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                    </span>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div >
        </>
    )
}

export default FeteManagement